<template>
  <div>
    <div id="css"></div>
    <div class="loading" id="load1" v-if="$store.state.load1" style="z-index:99999;">Loading&#8230;</div>
    <div class="loading" id="load" v-show="$store.state.load" style="z-index:99999;">Loading&#8230;</div>
    <div v-show="!$store.state.load">
      <div v-if="admin && $store.state.user">
        <div id="wrapper" v-if="loginAdmin">
          <ul v-if="$store.state.user.role === 'driver'" class="sidebar navbar-nav p-t-20">
            <li class="nav-item text-center">
              <a class="text-center" href="/" style="background: transparent;"><img :src="'/images/' + $store.state.option.logotipoBack" v-if="$store.state.option.logotipo" :alt="$store.state.option.empresa" style="max-width:90%" /></a>
            </li>
            <li><hr /></li>
            <li class="nav-item">
              <router-link exact class="nav-link" to="/admin-driver">
                <i class="fas fa-fw fa-tachometer-alt"></i>
                <span>&nbsp;{{$store.state.option['conta_pessoal_driver-deshboard-' + lang]}}</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link exact class="nav-link" to="/admin-user">
                <i class="fas fa-user"></i>
                <span>&nbsp;{{$store.state.option['conta_pessoal_driver-user-' + lang]}}</span>
              </router-link>
            </li>
            <li class="nav-item">
              <JimpiLogout :logoutTranslation="$store.state.option['conta_pessoal_client-logout-' + lang]"></JimpiLogout>
            </li>
          </ul>
          <ul v-if="$store.state.user.role === 'client'" class="sidebar navbar-nav p-t-20">
            <li class="nav-item text-center">
              <a class="text-center" href="/" style="background: transparent;"><img :src="'/images/' + $store.state.option.logotipoBack" v-if="$store.state.option.logotipo" :alt="$store.state.option.empresa" style="max-width:90%" /></a>
            </li>
            <li><hr /></li>
            <li class="nav-item">
              <router-link exact class="nav-link" to="/admin-driver">
                <i class="fas fa-user"></i>
                <span>&nbsp;{{$store.state.option['conta_pessoal_client-deshboard-' + lang]}}</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link exact class="nav-link" to="/admin-user">
                <i class="fas fa-fw fa-tachometer-alt"></i>
                <span>&nbsp;{{$store.state.option['conta_pessoal_client-user-' + lang]}}</span>
              </router-link>
            </li>
            <li class="nav-item">
              <JimpiLogout :logoutTranslation="$store.state.option['conta_pessoal_client-logout-' + lang]"></JimpiLogout>
            </li>
          </ul>
          <ul v-if="$store.state.user.role === 'admin'" class="sidebar navbar-nav p-t-20" >
            <li class="nav-item text-center">
              <a class="text-center" href="/" style="background: transparent;"><img :src="'/images/' + $store.state.option.logotipoBack" v-if="$store.state.option.logotipo" :alt="$store.state.option.empresa" style="max-width:90%" /></a>
            </li>
            <li><hr /></li>
            <li class="nav-item">
              <router-link exact class="nav-link" to="/admin">
                <i class="fas fa-fw fa-tachometer-alt"></i>
                <span>Dashboard</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/admin/pags/1">
                <i class="fas fa-file"></i>
                <span> Pages</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/admin/sitemap">
                <i class="fas fa-file"></i>
                <span> Sitemap</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/admin/extras">
                <i class="fas fa-car"></i>
                <span> Car Extras</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/admin/contacts">
                <i class="fas fa-address-book"></i>
                <span> Contacts</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/admin/users/1">
                <i class="fas fa-users"></i>
                <span> Users</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/admin/languages">
                <i class="fas fa-language"></i>
                <span> Languages</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/admin/questions">
                <i class="fas fa-question"></i>
                <span> Questions</span>
              </router-link>
            </li>
            <li class="nav-item">
              <JimpiLogout :logoutTranslation="$store.state.option['conta_pessoal_client-logout-' + lang]"></JimpiLogout>
            </li>
          </ul>

          <div id="content-wrapper">

              <div class="container-fluid">

                <h2 class="text-uppercase laranja">{{$store.state.titulo}}</h2>
                <hr style="margin-bottom:30px;">
                <router-view />

              </div>
              <div class="clearfix"></div><br />

              <footer class="sticky-footer">
                <div class="container my-auto">
                  <div class="copyright text-center my-auto">
                    <span>© {{$store.state.option.empresa}} {{new Date().getFullYear()}}. By <a href="https://www.emotionmobility.com" target="_blank">Emotion Mobility</a></span>
                  </div>
                </div>
              </footer>

            </div>
          </div>
          <div class="container" v-else>
            <router-view />
          </div>
      </div>

      <!--site normal-->
      <div v-else>
        <div id="nav" class="container pr">
          <b-navbar toggleable="lg" type="default" variant="default" class="p-t-0 p-b-50" style="padding-left:0px; padding-right:0px;">
            <ul class="lingua1 menuMobile m-0 p-0" style="border:none;" v-if="langs.length > 1">
              <li class="nav-item b-nav-dropdown dropdown">
                <a class="nav-link dropdown-toggle mao" @click="langShow = !langShow"><span>{{pais(lang, 1)}}</span></a>
                <ul :class="{'dropdown-menu': 1, 'show': langShow}">
                  <li class="mao p-l-10" v-show="dt != lang" @click="lang1(dt)" v-for="(dt, index) in langs" :key="index" v-html="pais(dt)"></li>
                </ul>
              </li>
            </ul>

            <b-navbar-brand href="/" class="p-b-20 p-0"><img v-if="$store.state.option.logotipo" :src="'/images/' + $store.state.option.logotipo" :alt="$store.state.option.empresa" style="max-height:90px;min-height:80px" /></b-navbar-brand>

            <a class="mao show-mobile float-right" style="font-size:25px" @click.stop="menu = !menu"><i class="fas fa-bars"></i></a>

            <div class="show-desktop" style="position: absolute; top:35px;right:0px;">
              <ul class="float-right lingua" v-if="langs.length > 1">
                <li class="nav-item b-nav-dropdown dropdown">
                  <a class="nav-link dropdown-toggle mao" @click="langShow = !langShow"><span>{{pais(lang)}}</span></a>
                  <ul :class="{'dropdown-menu': 1, 'show': langShow}">
                    <li class="mao p-l-10" v-show="dt != lang" @click="lang1(dt)" v-for="(dt, index) in langs" :key="index" v-html="pais(dt)"></li>
                  </ul>
                </li>
              </ul>

              <JimpiLogoutFloatRight :logoutTranslation="$store.state.option['logout-' + lang]"></JimpiLogoutFloatRight>

              <router-link v-if="!$store.state.user" class="login float-right" to="/login"  style="background:none !important;color:#333 !important;"><i class="fas fa-user" style="height:auto;"></i> <span v-html="$store.state.option['reserved_area-' + lang]"></span><br /><b class="laranja">{{$store.state.option['login-' + lang]}}</b></router-link>
              <router-link v-if="$store.state.user.role === 'client'" style="background:none !important;color:#333 !important;" class="login float-right" to="/admin-client"><i class="fas fa-user" style="height:auto;"></i> <span v-html="$store.state.option['reserved_area-' + lang]"></span><br />{{$store.state.user.driver_Name || $store.state.user.Name}}</router-link>
              <router-link v-if="$store.state.user.role === 'driver'" style="background:none !important;color:#333 !important;" class="login float-right" to="/admin-driver"><i class="fas fa-user" style="height:auto;"></i> <span v-html="$store.state.option['reserved_area-' + lang]"></span><br />{{$store.state.user.driver_Name || $store.state.user.Driver_Name}}</router-link>
              <router-link v-if="$store.state.user.role === 'admin'" style="background:none !important;color:#333 !important;" class="login float-right" to="/admin"><i class="fas fa-user" style="height:auto;"></i> <span v-html="$store.state.option['reserved_area-' + lang]"></span><br />ADMIN</router-link>

            </div>

            <b-collapse id="nav-collapse" is-nav>
              <b-navbar-nav class="ml-auto">
                <router-link exact class="menu-link-top" to="/">{{$store.state.option['home-' + lang]}}</router-link>
                <router-link exact class="menu-link-top" to="/car">{{$store.state.option['car-' + lang]}}</router-link>
                <router-link v-if="$store.state.option.company !=='7531'" exact class="menu-link-top" to="/station">{{$store.state.option['stations-' + lang]}}</router-link>
                <router-link exact class="menu-link-top" to="/news/1">{{$store.state.option['news-' + lang]}}</router-link>
                <!-- <div v-for="(dt, index) in paginas" :key="index" v-show="dt.menu > 0 && dt.active > 0" style="margin-top: 0.9em">
                  <div v-if="dt.menu > 0 && dt.active > 0">
                    <a v-if="dt.external_link !== null" :href="dt.external_link" class="menu-link-top" target="_blank">{{dt.title}}</a>
                    <router-link v-else exact class="menu-link-top" :to="goToPage(dt)">{{dt.title}}</router-link>
                  </div>
                </div> -->
                <router-link exact v-show="dt.menu > 0 && dt.active > 0 && dt.external_link === null" class="menu-link-top" :to="goToPage(dt)" v-for="(dt, index) in paginas_menu" :key="index">{{dt.title}}</router-link>
                <router-link exact class="menu-link-top" to="/contacts">{{$store.state.option['contacts-' + lang]}}</router-link>
              </b-navbar-nav>
            </b-collapse>
          </b-navbar>
        </div>
        <div v-if="menu">
          <ul class="menuMobile p-0 m-0 b-000 c-fff">
            <li><router-link exact class="menu-link-top p-t-30" to="/car">{{$store.state.option['car-' + lang]}}</router-link></li>
            <li><router-link v-if="$store.state.option.company !=='7531'" exact class="menu-link-top" to="/station">{{$store.state.option['stations-' + lang]}}</router-link></li>
            <li><router-link exact class="menu-link-top" to="/news/1">{{$store.state.option['news-' + lang]}}</router-link></li>
            <li v-for="(dt, index) in paginas" :key="index">
              <router-link exact v-show="dt.menu > 0 && dt.active > 0 && dt.external_link == null" class="menu-link-top" :to="goToPage(dt)">{{dt.title}}</router-link>
              <a v-show="dt.menu > 0 && dt.active > 0 && dt.external_link !== null" :href="dt.external_link">{{dt.title}}</a>
            </li>
            <li><router-link exact class="menu-link-top" to="/contacts">{{$store.state.option['contacts-' + lang]}}</router-link></li>
            <li>
              <router-link v-if="!$store.state.user" exact class="menu-link-top" to="/login">{{$store.state.option['reserved_area-' + lang]}}</router-link>
              <router-link v-if="$store.state.user.role === 'client'" class="menu-link-top" to="/admin-client">{{$store.state.option['reserved_area-' + lang]}}</router-link>
              <router-link v-if="$store.state.user.role === 'driver'" class="menu-link-top" to="/admin-driver">{{$store.state.option['reserved_area-' + lang]}}</router-link>
              <router-link v-if="$store.state.user.role === 'admin'" class="menu-link-top" to="/admin">{{$store.state.option['reserved_area-' + lang]}}</router-link>
            </li>
            <li v-if="$store.state.user">
              <!-- <a class="menu-link-top p-b-30" href="/backoffice/logout">{{$store.state.option['logout-' + lang]}}</a> -->
              <JimpiLogoutMenuTop :logoutTranslation="$store.state.option['logout-' + lang]"></JimpiLogoutMenuTop>
            </li>
          </ul>
        </div>
        <div class="clearfix"></div>
        <div id="content">
          <router-view />
        </div>
        <div id="noticias" class="b-cinzento p-t-30" v-if="noticias.length && $route.name !== 'contactos' && $route.name !== 'login' && $route.name !== 'recuperar' && $route.name !== 'registar' && $route.name !== 'frota1' && $route.name !== 'frota' && $route.name !== 'noticias'">
          <div class="container1 pr text-center">
            <div class="barra"></div>
            <h2 class="text-center text-uppercase laranja p-t-20 z-10 pr b-cinzento titulo">{{$store.state.option['home_news-' + lang]}}</h2>
            <h5 class="text-center text-uppercase">{{$store.state.option['home_news1-' + lang]}}</h5>
          </div>
          <div style="width:100%; max-width:1600px;margin: 0 auto;">
            <b-card-group>
              <b-card class="mao" v-show="dt.active > 0" @click="$router.push('/new/' + dt.slug, () => {})" :img-src="dt.capa ? '/images/' + dt.capa : '/img/img1.png'" :img-alt="dt.title" img-bottom v-for="(dt, index) in noticias" :key="index">
                <b-card-text class="text-center">
                  <h4>{{dt.title}}</h4>
                </b-card-text>
              </b-card>
            </b-card-group>
          </div>
        </div>
        <div id="footer" class="container p-50" v-if="$route.name !== 'noticias'">
          <div class="show-desktop">
            <b-navbar toggleable="lg" type="default" variant="default">
              <b-navbar-brand style="font-size: 0.8rem;float:left;top: -25px;position: relative;"><img v-if="$store.state.option.logotipo" :src="'/images/' + $store.state.option.logotipo" :alt="$store.state.option.empresa" class="m-r-10" style="max-height:58px" /> {{$store.state.option['copyright-' + lang]}}</b-navbar-brand>
              <div style="position:absolute;right:0px;">
                <div class="footer-menu1">
                  <template v-for="(dt, index) in paginas_footer1">
                    <span v-if="dt.footer_top > 0 && dt.active > 0" style="background: none !important;" class="laranja m-h-10" :key="index">
                        <router-link v-if="dt.external_link == null" exact :to="goToPage(dt)">{{dt.title}}</router-link>
                        <a v-if="dt.external_link !== null" :href="dt.external_link" target="_blank">{{dt.title}}</a>
                    </span>
                  </template>
                <button @click="reopenCookiePreferences" class="btn custom-btn-link">
                  Cookies Settings
                </button>
                </div>
                <div class="clearfix"></div>
                <div class="footer-menu2">
                  <router-link exact to="/">{{$store.state.option['home-' + lang]}}</router-link>
                  <router-link exact to="/car">{{$store.state.option['car-' + lang]}}</router-link>
                  <router-link v-if="$store.state.option.company !=='7531'" exact to="/station">{{$store.state.option['stations-' + lang]}}</router-link>
                  <router-link exact to="/news/1">{{$store.state.option['news-' + lang]}}</router-link>
                  <span v-for="(dt, index) in paginas_footer2" :key="index" >
                    <router-link v-show="dt.bottom > 0 && dt.active > 0 && dt.external_link == null" exact :to="goToPage(dt)">{{dt.title}}</router-link>
                    <a v-show="dt.bottom > 0 && dt.active > 0 && dt.external_link !== null" :href="dt.external_link" target="_blank">{{dt.title}}</a>
                  </span>
                  <router-link exact to="/contacts">{{$store.state.option['contacts-' + lang]}}</router-link>
                  <router-link v-if="$store.state.user.role === 'admin'" exact to="/admin">{{$store.state.option['reserved_area-' + lang]}}</router-link>
                  <router-link v-if="$store.state.user.role === 'driver'" exact to="/admin-driver">{{$store.state.option['reserved_area-' + lang]}}</router-link>
                  <router-link v-if="$store.state.user.role === 'client'" exact to="/admin-client">{{$store.state.option['reserved_area-' + lang]}}</router-link>
                  <router-link v-if="!$store.state.user" exact to="/login">{{$store.state.option['login-' + lang]}}</router-link>
                </div>
              </div>
            </b-navbar>
          </div>
          <div>
            <ul class="menuMobile p-0" style="border:none;">
              <li><router-link exact class="menu-link-top" to="/car" right>{{$store.state.option['car-' + lang]}}</router-link></li>
              <li><router-link v-if="$store.state.option.company !=='7531'" exact class="menu-link-top" to="/station" right>{{$store.state.option['stations-' + lang]}}</router-link></li>
              <li><router-link exact class="menu-link-top" to="/news/1" right>{{$store.state.option['news-' + lang]}}</router-link></li>
              <li v-for="(dt, index) in paginas" :key="index">
                <router-link v-show="dt.bottom > 0 && dt.active > 0 && dt.external_link == null" class="menu-link-top" exact :to="goToPage(dt)" right>{{dt.title}}</router-link>
                <a :href="dt.external_link" v-show="dt.bottom > 0 && dt.active > 0 && dt.external_link !== null" target="_blank">{{dt.title}}</a>
              </li>
              <li><router-link exact class="menu-link-top" to="/contacts" right>{{$store.state.option['contacts-' + lang]}}</router-link></li>
              <li>
                <router-link class="menu-link-top" v-if="$store.state.user.role === 'admin'" exact to="/admin">{{$store.state.option['reserved_area-' + lang]}}</router-link>
                <router-link class="menu-link-top" v-if="$store.state.user.role === 'client'" exact to="/admin-client">{{$store.state.option['reserved_area-' + lang]}}</router-link>
                <router-link class="menu-link-top" v-if="$store.state.user.role === 'driver'" exact to="/admin-driver">{{$store.state.option['reserved_area-' + lang]}}</router-link>
                <router-link class="menu-link-top" v-if="!$store.state.user" exact to="/login">{{$store.state.option['login-' + lang]}}</router-link>
              </li>
            </ul>
          </div>
        </div>
        <div id="EXTERNAL_CUSTOM_SCRIPT"></div>
        <div id="footerSocial" class="b-cinzento p-50 text-center">
          <a v-if="$store.state.option.facebook" :href="$store.state.option.facebook" target="_blank" class="social facebook"><i class="fab fa-facebook"></i></a>
          <a v-if="$store.state.option.twitter" :href="$store.state.option.twitter" target="_blank" class="social twitter"><i class="fab fa-twitter"></i></a>
          <a v-if="$store.state.option.youtube" :href="$store.state.option.youtube" target="_blank" class="social youtube"><i class="fab fa-youtube"></i></a>
          <a v-if="$store.state.option.instagram" :href="$store.state.option.instagram" target="_blank" class="social instagram"><i class="fab fa-instagram"></i></a>
          <a v-if="$store.state.option.linkedin" :href="$store.state.option.linkedin" target="_blank" class="social linkedin"><i class="fab fa-linkedin"></i></a>
          <a v-if="$store.state.option.skype" :href="$store.state.option.skype" target="_blank" class="social skype"><i class="fab fa-skype"></i></a>
          <a v-if="$store.state.option.whatsapp" :href="$store.state.option.whatsapp" target="_blank" class="social whatsapp"><i class="fab fa-whatsapp"></i></a>
          <a v-if="$store.state.option.pinterest" :href="$store.state.option.pinterest" target="_blank" class="social pinterest"><i class="fab fa-pinterest"></i></a>
          <a v-if="$store.state.option.viber" :href="$store.state.option.viber" target="_blank" class="social viber"><i class="fab fa-viber"></i></a>
          <a v-if="$store.state.option.reddit" :href="$store.state.option.reddit" target="_blank" class="social reddit"><i class="fab fa-reddit"></i></a>
          <a v-if="$store.state.option.qq" :href="$store.state.option.qq" target="_blank" class="social qq"><i class="fab fa-qq"></i></a>
        </div>
      </div>
    </div>

    <div v-if="showCookieBanner" class="cookie-container">
      <div class="cookie-popup">
        <h4>{{ $store.state.option["cookies-title-" + lang] }}</h4>

        <div
          class="text-left"
          style="font-size: 10pt"
          v-html="$store.state.option['cookies-desc-' + lang]"
        ></div>
        <hr />

        <div class="card-content">
          <div class="card">
            <div>
              <h6>{{ $store.state.option["cookies-title-essentials-" + lang] }}</h6>
              <p>
                {{ $store.state.option["cookies-description-essentials-" + lang] }}
              </p>
            </div>

            <input type="checkbox" checked disabled />
          </div>

          <div class="card">
            <div>
              <h6>{{ $store.state.option["cookies-title-statistics-" + lang] }}</h6>
              <p>
                {{ $store.state.option["cookies-description-statistics-" + lang] }}
              </p>
            </div>

            <input type="checkbox" v-model="cookiesStatistics" />
          </div>

          <div class="card">
            <div>
              <h6>{{ $store.state.option["cookies-title-marketing-" + lang] }}</h6>
              <p>
                {{ $store.state.option["cookies-description-marketing-" + lang] }}
              </p>
            </div>

            <input type="checkbox" v-model="cookiesMarketing" />
          </div>
        </div>

        <div class="text-center" style="display: flex; justify-content: space-between; margin-top: 20px; align-items: center;">
          <p class="m-y-0" @click="chooseCookies('reject-all')" style="color: #7f7f7f;cursor: pointer;" >
            {{ $store.state.option["cookies-reject-all-" + lang] }}
          </p>

          <div style="display: flex; gap: 10px; align-items: center;">
            <p class="m-y-0" @click="chooseCookies('accept')" style="color: #7f7f7f;cursor: pointer;" >
              {{ $store.state.option["cookies-accept-selected-" + lang] }}
            </p>
            <button class="skew btn btn-primary m-x-5 no-focus" @click="chooseCookies('accept-all')">
              {{ $store.state.option["cookies-accept-all-" + lang] }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import './assets/css/fontawesome-free/css/all.min.css'
import './assets/css/sb-admin.css'
import { mapMutations } from 'vuex'
import PAISES from './components/paises.json'
import JimpiLogout from './components/logout/logout'
import JimpiLogoutFloatRight from './components/logout/logout-floatRight'
import JimpiLogoutMenuTop from './components/logout/logout-menuTop'

export default {
  // This represent the dynamic meta tags used by google crawlers which show the result in google search
  metaInfo () {
    if (this.$store.state.option.metaTitle || this.$store.state.option.metaDescription || this.$store.state.option.metaKeywords) {
      return {
        title: this.$store.state.option.empresa,
        meta: [
          { name: 'title', content: this.$store.state.option.metaTitle },
          { name: 'description', content: this.$store.state.option.metaDescription },
          { name: 'keywords', content: this.$store.state.option.metaKeywords }
        ]
      }
    }
  },
  components: { JimpiLogout, JimpiLogoutFloatRight, JimpiLogoutMenuTop },
  data () {
    return {
      loginAdmin: false,
      admin: false,
      menu: true,
      langs: ['GB'],
      paises: PAISES,
      langShow: false,
      noticias: [],
      paginas: [],
      lang: 'GB',
      paginas_footer1: [],
      paginas_footer2: [],
      paginas_menu: [],
      showCookieBanner: !(localStorage.getItem('cookiesAccepted') === 'true'),
      cookiesStatistics: false,
      cookiesMarketing: false
    }
  },
  mounted () {
    /*
    if (window.location.protocol !== 'https:') {
      window.location = window.location.href.replace('http:', 'https:')
    }
    */
    this.SET_OPTIONS1(false)
    this.init()
  },
  watch: {
    '$route' (b, c) {
      this.menu = false
      window.scrollTo(0, 0)
      if (b.name.indexOf('admin') === 0) {
        if (this.$store.state.user) {
          this.loginAdmin = true
          this.admin = true
        } else {
          this.loginAdmin = false
          this.admin = false
          // this.$router.push('/', () => {})
        }
      } else {
        this.loginAdmin = false
        this.admin = false
      }
    },
    '$store.state.aviso' (b, c) {
      this.SET_LOAD1()
      this.SET_LOAD()
      if (b) {
        let erro = b
        if (this.$store.state.option[b + '-' + this.lang]) {
          erro = this.$store.state.option[b + '-' + this.lang]
        }
        this.SET_AVISO('')
        if (parseInt(erro) > 0) {
          this.$swal({
            title: erro,
            type: 'error'
          })
        } else {
          this.$swal({
            title: erro,
            type: 'error'
          })
        }
      }
    },
    '$store.state.toast' (val) {
      if (val.msg) {
        this.$swal({
          position: 'top-end',
          type: val.type || 'success',
          title: val.msg,
          showConfirmButton: false,
          timer: 4000,
          toast: true,
          stopKeydownPropagation: false
        })
        this.SET_TOAST('')
        this.SET_LOAD()
        this.SET_LOAD1()
      }
    }
    /*
    '$store.state.logout' (b, c) {
      this.SET_LOAD1(true)
      if (b) {
        this.SET_LOGOUT('')
        document.cookie = ''
        this.SET_USER('')
        this.$router.push('/', () => {})
        this.loginAdmin = false
        this.admin = false
        this.axios.get('/backoffice/logout').then((res) => {
          this.SET_LOAD1()
        }, (er) => {
          this.SET_LOAD1()
        })
      }
    }
    */
  },
  methods: {
    ...mapMutations([
      'SET_LANG',
      'SET_AVISO',
      // 'SET_LOGOUT',
      'SET_USER',
      'SET_LOAD',
      'SET_LOAD1',
      'SET_TOAST',
      'SET_OPTIONS',
      'SET_OPTIONS1',
      'SET_STATIONS',
      'SET_STATIONS1',
      'SET_PAISES',
      'SET_CARS',
      'SET_DRIVER'
    ]),
    init () {
      this.sessao()
      this.axios.get('/stations').then((res) => {
        this.SET_STATIONS(res.data)
        this.SET_STATIONS1(true)
      }, (er) => {})

      this.axios.get('/options').then((res) => {
        this.SET_OPTIONS(res.data)
        this.SET_OPTIONS1(true)
        this.setChat(res.data.company)
        this.langs = JSON.parse(this.$store.state.option.langs)
        this.lang1(this.$localStorage.get('lang'), 1)

        this.axios.get('/pages?type=page&active=1&language=' + this.lang).then((res) => {
          this.paginas = res.data.data
          this.assignAndOrderPages()
        }, (er) => {
          this.paginas = []
        })
        this.axios.get('/pages?type=news&active=1&limit=3&language=' + this.lang).then((res) => {
          this.noticias = res.data.data
          this.SET_LOAD()
        }, (er) => {
          this.noticias = []
        })
        this.axios.get('/cars').then((res) => {
          this.SET_CARS(res.data)
        }, (er) => {})
        this.axios.get('/countries').then((res) => {
          this.SET_PAISES(res.data)
        }, (er) => {})

        let cor = res.data.cor || '#ff6600'
        let r = 0
        let g = 0
        let b = 0
        if (cor.length === 4) {
          r = '0x' + cor[1] + cor[1]
          g = '0x' + cor[2] + cor[2]
          b = '0x' + cor[3] + cor[3]
        } else {
          if (cor.length === 7) {
            r = '0x' + cor[1] + cor[2]
            g = '0x' + cor[3] + cor[4]
            b = '0x' + cor[5] + cor[6]
          }
        }
        document.getElementById('css').innerHTML = '<style type="text/css">.laranja,.vueperslides__arrow--prev, .vueperslides__arrow--next, .menu-link-top:hover, a, .mx-panel-date td.today {color:' + cor + ';} .b-laranja, .active, .btn-primary, ul.pagination>li.page-item>a.page-link, .btn-primary:active, .mx-calendar-content .cell.actived, .mx-calendar-content .cell:hover, .swal2-confirm {background:' + cor + '!important;} .btn-primary, .btn-primary:active, ul.pagination>li.page-item>a.page-link {border-color:' + cor + ';} .bordaSearch {border-color: rgb(' + +r + ', ' + +g + ', ' + +b + ', 0.5) !important;} a:hover {color:#333;}</style>'
      }, (er) => {
        // this.SET_AVISO(er.response.data.error)
      })
    },
    // seleccionar lingua e guarda no localstorage
    lang1 (lang, refresh) {
      if (!lang) {
        lang = (window.navigator.language || window.navigator.browserLanguage).toUpperCase()
        if (lang) {
          lang = lang.split('-')[0]
        }
      }
      if (!(this.langs.find(a => a === lang))) {
        lang = 'GB'
      }
      this.SET_LANG(lang)
      this.lang = lang
      this.$localStorage.set('lang', lang)
      this.langShow = false
      if (!refresh) {
        this.$router.replace('/', () => {})
        window.location.reload()
      }
    },
    // imprime a bandeira e as linguas a seleccionar
    pais (dt, x) {
      let pais = this.paises.find(a => a.code === dt)
      if (pais) {
        if (x) {
          return pais.emoji
        }
        return pais.emoji + ' ' + pais.name
      }
      return dt
    },
    sessao (a) {
      this.axios.get('/users').then((res) => {
        this.SET_USER(res.data)
        switch (res.data.role) {
          case 'admin':
          case 'driver':
          case 'client':
            if (this.$route.name.indexOf('admin') === 0) {
              this.admin = true
              this.loginAdmin = true
            }
            break
          default:
            this.loginAdmin = false
            this.admin = false
        }
        if (res.data.role === 'client' && !this.$store.state.drivers1) {
          this.axios.get('/drivers').then((res) => {
            if (res.data.error) {
            } else {
              this.SET_DRIVER(res.data)
            }
          }, (er) => {})
        }
      }, (er) => {
        this.SET_DRIVER([])
        this.SET_USER('')
        this.loginAdmin = false
        this.admin = false
      })
      this._.delay(this.sessao, 120000, 1)
    },

    chooseCookies (value) {
      localStorage.setItem('cookiesAccepted', true)

      this.deleteAllCookiesExceptRentsession()

      if (value === 'accept' || value === 'accept-all') {
        const setAllCookie = value === 'accept-all'

        if (setAllCookie || this.cookiesStatistics) this.setCookiesStatistics()
        if (setAllCookie || this.cookiesMarketing) this.setCookiesMarketing()

        localStorage.setItem('cookiesStatistics', setAllCookie || this.cookiesStatistics)
        localStorage.setItem('cookiesMarketing', setAllCookie || this.cookiesMarketing)
      } else {
        localStorage.setItem('cookiesStatistics', false)
        localStorage.setItem('cookiesMarketing', false)
      }

      this.showCookieBanner = false
    },

    deleteAllCookiesExceptRentsession () {
      const cookies = document.cookie.split(';')
      cookies.forEach(cookie => {
        const currentDomain = window.location.hostname
        const cookieName = cookie.split('=')[0].trim()
        if (!cookieName.startsWith('rentsession')) {
          // Delete the cookie by setting its expiration date to the past
          document.cookie = cookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=' + currentDomain
        }
      })
    },

    reopenCookiePreferences () {
      this.cookiesStatistics = localStorage.getItem('cookiesStatistics') ? (localStorage.getItem('cookiesStatistics') === 'true') : true
      this.cookiesMarketing = localStorage.getItem('cookiesMarketing') ? (localStorage.getItem('cookiesMarketing') === 'true') : true

      this.showCookieBanner = true
    },
    setChat (company) {
      /**
       * ILHA VERDE SET BY COMPANY FROM OPTION VUEX 9926
       * needs to be loaded after teh vuex state is loaded
       */
      if (company === '9926') {
        const docScript = document.createElement('script')
        docScript.type = 'text/javascript'
        docScript.innerHTML = `var _smartsupp = _smartsupp || {};_smartsupp.key = '9d65414c2d31020963894133679640b003e5fc66';window.smartsupp||(function(d) {
            var s,c,o=smartsupp=function(){ o._.push(arguments)};o._=[];s=d.getElementsByTagName('script')[0];c=d.createElement('script');c.type='text/javascript';c.charset='utf-8';c.async=true;
            c.src='https://www.smartsuppchat.com/loader.js?';s.parentNode.insertBefore(c,s);})(document);`
        document.head.appendChild(docScript)
      }
      /**
       * BERNARDINI LOCATION - ADA-CORSE.COM SET BY COMPANY FROM OPTION VUEX 7509
       * needs to be loaded after teh vuex state is loaded
       * ! because of this various content security policy (headers):
       * script-src self js.ada-corse.com;
       * default-src 'self';
       * style-src 'self' css.ada-corse.com;
       */
      if (company === '7509') {
        const docScript = document.createElement('script')
        docScript.id = 'ze-snippet'
        docScript.src = 'https://static.zdassets.com/ekr/snippet.js?key=277d7916-5086-4a04-88eb-c5457a46e624'
        document.head.appendChild(docScript)
      }
      // /** MADEIRARENT */
      // if (company === '8118') {
      //   const docScript = document.createElement('script')
      //   docScript.type = 'text/javascript'
      //   docScript.innerHTML = `window.__lc = window.__lc || {};
      //     window.__lc.license = 13828062;
      //     ;(function(n,t,c){function i(n){return e._h?e._h.apply(null,n):e._q.push(n)}var e={_q:[],_h:null,_v:"2.0",on:function(){i(["on",c.call(arguments)])},once:function(){i(["once",c.call(arguments)])},off:function(){i(["off",c.call(arguments)])},get:function(){if(!e._h)throw new Error("[LiveChatWidget] You can't use getters before load.");return i(["get",c.call(arguments)])},call:function(){i(["call",c.call(arguments)])},init:function(){var n=t.createElement("script");n.async=!0,n.type="text/javascript",n.src="https://cdn.livechatinc.com/tracking.js",t.head.appendChild(n)}};!n.__lc.asyncInit&&e.init(),n.LiveChatWidget=n.LiveChatWidget||e}(window,document,[].slice))`
      //   document.head.appendChild(docScript)
      // }
    },
    setCookiesStatistics () {
      this.setGoogleAnalytics()
    },

    setCookiesMarketing () {
      this.facebookPixel()
    },

    setGoogleAnalytics () {
      if (this.$store.state.option.idGoogleAnalytics && localStorage.cookiesAccepted) {
        const scriptGoogleAnalytics = document.createElement('script')
        scriptGoogleAnalytics.async = true
        scriptGoogleAnalytics.src = `https://www.googletagmanager.com/gtag/js?id=${this.$store.state.option.idGoogleAnalytics}`
        document.head.appendChild(scriptGoogleAnalytics)
        const scriptDatalayers = document.createElement('script')
        scriptDatalayers.innerHTML = `window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments)} gtag('js', new Date()); gtag('config', '${this.$store.state.option.idGoogleAnalytics}');`
        document.head.appendChild(scriptDatalayers)

        // IMPLEMENTAION: https://stackoverflow.com/questions/70327150/how-to-dynamically-loading-google-tag-manager-id-on-index-html-for-different-env
        this.activateGtm(window, document, 'script', 'dataLayer', this.$store.state.option.idGoogleTagManager)
      }
    },

    activateGtm (w, d, s, l, i) {
      w[l] = w[l] || []
      w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
      let f = d.getElementsByTagName(s)[0]
      let j = d.createElement(s)
      let dl = l !== 'dataLayer' ? `&l=${l}` : ''
      j.async = true
      j.src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}`
      f.parentNode.insertBefore(j, f)
      /** NOSCRIPT SECTION */
      // const scriptGoogleTag = document.createElement('iframe')
      // scriptGoogleTag.src = `https://www.googletagmanager.com/ns.html?id=${this.$store.state.option.idGoogleTagManager}`
      // scriptGoogleTag.style.height = '0'
      // scriptGoogleTag.style.width = '0'
      // scriptGoogleTag.style.display = 'none'
      // scriptGoogleTag.style.visibility = 'hidden'
      // document.noscript.appendChild(scriptGoogleTag)
      const noscript = document.createElement('noscript')
      const iframe = document.createElement('iframe')

      iframe.src = `https://www.googletagmanager.com/ns.html?id=${this.$store.state.option.idGoogleTagManager}`
      iframe.height = '0'
      iframe.width = '0'
      iframe.style.display = 'none'
      iframe.style.visibility = 'hidden'

      noscript.appendChild(iframe)
      document.body.appendChild(noscript)
    },

    facebookPixel () {
      if (this.$store.state.option.facebookPixelId && localStorage.cookiesAccepted) {
        const docScript = document.createElement('script')
        docScript.type = 'text/javascript'
        docScript.innerHTML = `
          !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', ${this.$store.state.option.facebookPixelId});
          fbq('track', 'PageView');
          fbq('track', 'ViewContent');
        `
        document.head.appendChild(docScript)
        const docNoscript = document.createElement('noscript')
        docNoscript.type = 'text/javascript'
        const docImage = document.createElement('img')
        docImage.height = '1'
        docImage.width = '1'
        docImage.style.display = 'none'
        docImage.src = `https://www.facebook.com/tr?id=${this.$store.state.option.facebookPixelId}&ev=PageView&noscript=1`
        docNoscript.appendChild(docImage)
        document.head.appendChild(docNoscript)
      }
    },

    goToPage (dt) {
      return '/pags/' + dt.slug
    },

    assignAndOrderPages () {
      this.paginas_menu = this.paginas.filter(x => x.menu === 1)
      this.paginas_menu.sort((a, b) => a.order_menu - b.order_menu)
      this.paginas_footer1 = this.paginas.filter(x => x.footer_top === 1)
      this.paginas_footer1.sort((a, b) => a.order_footer1 - b.order_footer1)
      this.paginas_footer2 = this.paginas.filter(x => x.bottom === 1)
      this.paginas_footer2.sort((a, b) => a.order_footer2 - b.order_footer2)
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Oswald');
html,body,a, h1, h2, h3, h4, h5, h6, span, p, div {font-family: 'Roboto', sans-serif;}

div, pre, p, span {word-break:  break-word !important;}

#footerSocial a {cursor:pointer;}
.social {font-size:2rem;margin: 0px 10px 0px 10px;color:#333;}
.youtube:hover {color:#ff0100 !important;}
.twitter:hover {color:#00ACEE !important;}
.facebook:hover {color:#3b5998 !important;}
.instagram:hover {color:#833AB4 !important;}
.linkedin:hover {color:#0E76A8 !important;}
.skype:hover {color:#00AFF0 !important;}
.whatsapp:hover {color:#4FCE5D !important;}
.pinterest:hover {color:#C8232C !important;}
.viber:hover {color:#665CAC !important;}
.reddit:hover {color:#FF4301 !important;}
.qq:hover {color:#37474f !important;}

.sidebar {min-height: 100vh;}

#nav-collapse {position: absolute;bottom:0px;left:0px;}
.menu-link-top {color:#333;padding:15px;text-transform: uppercase;text-decoration: none !important;}
#nav .active {color:#fff !important;text-decoration:none !important}
.login {text-decoration:none;color:#999;padding-left:40px;font-size:13px;}
.login i {font-size: 34px;position:absolute;height:100vh;left:0px;}
.lingua {list-style: none;}
.sair {margin-left: 30px;padding-top: 5px;}

#footer {position:relative;border-top: solid 1px rgb(242,242,242);}
.footer-menu1 {float:right;border-bottom: solid 2px rgb(242,242,242); margin-bottom:10px;padding-bottom:10px;}
.footer-menu1 a:hover,.footer-menu2 a:hover {color:#333;text-decoration: none;}
.footer-menu2 {float:right;}
.footer-menu2 .active {background:transparent !important;color:#333 !important;font-weight:bold;}
.footer-menu2 a {margin: 0px 10px;color:#999;}

.mao {cursor: pointer;}
.card img {border-radius: 0px !important;}

.cinzento {color: rgb(242,242,242);}
.cinzento1 {color: rgb(195,195,195);}
.a-cor {color: #212529;}
.preto {color: #333;}
.branco {color: #fff;}
.b-branco {background:#fff;}
.b-cinzento {background: rgb(242,242,242);}
.b-cinzento1 {background: rgb(195,195,195);}
.p-0 {padding:0px;}
.p-50 {padding:50px;}
.p-20 {padding:20px;}
.p-15 {padding:15px;}
.p-10 {padding:10px;}
.p-r-10 {margin-top:10px;}
.m-0 {margin:0px;}
.p-l-10 {padding-left:10px;}
.p-l-20 {padding-left:20px;}
.p-b-0 {padding-bottom: 0px;}
.p-b-20 {padding-bottom: 20px;}
.p-b-5 {padding-bottom: 5px;}
.p-t-20 {padding-top:20px;}
.p-t-50 {padding-top:50px;}
.m-t-20 {margin-top:20px;}
.p-t-30 {padding-top:30px;}
.p-t-30 {padding-top:30px;}
.p-t-40 {padding-top:40px;}
.p-t-20 {padding-top:20px;}
.p-b-30 {padding-top:30px;}
.p-v-60 {padding-top:60px;padding-bottom:60px;}
.m-h-5 {margin-right:5px;margin-left:5px;}
.m-h-10 {margin-right:10px;margin-left:10px;}
.p-b-60 {padding-bottom:60px;}
.m-t-100 {margin-top:100px;}
.m-t-10 {margin-top:10px;}
.m-t-30 {margin-top:30px;}
.p-t-5 {padding-top:5px;}
.m-t-50 {margin-top:50px;}
.m-b-0 {margin-bottom:0px;}
.m-b-10 {margin-bottom:10px;}
.m-b-20 {margin-bottom:20px;}
.m-b-30 {margin-bottom:30px;}
.p-v-50 {padding-top: 50px; padding-bottom: 50px;}
.p-v-30 {padding-top: 30px; padding-bottom: 30px;}
.p-v-20 {padding-top: 20px; padding-bottom: 20px;}
.p-v-10 {padding-top: 10px; padding-bottom: 10px;}
.p-v-5 {padding-top: 5px; padding-bottom: 5px;}
.m-15 {margin: 15px;}
.m-y-0 {margin-bottom:0px; margin-top: 0px;}
.m-x-5 {margin-right:5px; margin-left: 5px;}
.m-v-50 {margin-top:50px;margin-bottom:50px;}
.m-v-10 {margin-top:10px;margin-bottom:10px;}
.m-r-10 {margin-right:10px;}
.m-l-15 {margin-left:15px;}
.m-h-100 {max-height:100px;}
.w-110 {width:110px;}
.w-41 {width:41px;}
.no-wrap {word-wrap:break-word;}
.b-000 {background:#000;}
.c-fff a {color:#fff;}
.oculto {display:none !important;}
.full-width {width:100%;}

#slideSearch {position: absolute;bottom:0px; left: calc(50% - 300px); max-width:600px;z-index:999;}
.bordaSearch {border: solid 15px; border-bottom: none;}
.bordaSlideshow {height:15px;background: rgb(242,242,242);width:100%;}
.borda {border: solid 1px #ccc !important;}
.borda-b {border-bottom: solid 1px #ccc !important;}

.seta {
  border-top: 32px solid transparent;
  border-bottom: 32px solid transparent;
  border-left: 32px solid #fff;
  height:32px;
  width:32px;
  position: absolute;
  right:10px;
}
.quadrado {overflow: hidden;}
.quadrado1 {}
.redondo {border-radius: 50%;width:50px;height:50px;text-align: center;float:left;line-height:50px;position: relative;top: -13px;left: -13px;}
.disabled1 {pointer-events: none;opacity: 0.4;}

ul.pagination > li.page-item > a.page-link {color:#333 !important;}
ul.pagination > li.page-item.active > a.page-link {color:#fff !important;}
ul.pagination > li.page-item.active {background: none !important;}

.card {border:none !important; margin:20px;}

.z-10 {z-index:10;}
.pr {position:relative;}
.barra {border: solid 1px rgb(195,195,195);position:absolute; top:38px; width:100%;}
.titulo {width:auto; display: inline-block; padding-right:50px;padding-left: 50px;}
.container1 {max-width:900px;margin: 0 auto;}

ul.menuMobile {list-style: none;border-top: solid 2px rgb(242,242,242);display:none;}
ul.menuMobile li {display:block;}
ul.menuMobile li a {display:block; text-align:center;}
.show-mobile,.show-desktop {display:none;}
@media screen and (max-width:991px){
  ul.menuMobile, .show-mobile {display:block;}
}
@media screen and (min-width:991px){
  .show-desktop {display:block;}
  .p-b-50 {padding-bottom:50px;}
}

/* Absolute Center Spinner */
.loading {
  position: fixed;
  z-index: 999;
  height: 2em;
  width: 2em;
  overflow: visible;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

/* Transparent Overlay */
.loading:before {
  content: '';
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.3);
}

/* :not(:required) hides these rules from IE9 and below */
.loading:not(:required) {
  /* hide "loading..." text */
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}

.loading:not(:required):after {
  content: '';
  display: block;
  font-size: 10px;
  width: 1em;
  height: 1em;
  margin-top: -0.5em;
  -webkit-animation: spinner 1500ms infinite linear;
  -moz-animation: spinner 1500ms infinite linear;
  -ms-animation: spinner 1500ms infinite linear;
  -o-animation: spinner 1500ms infinite linear;
  animation: spinner 1500ms infinite linear;
  border-radius: 0.5em;
  -webkit-box-shadow: rgba(0, 0, 0, 0.75) 1.5em 0 0 0, rgba(0, 0, 0, 0.75) 1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) 0 1.5em 0 0, rgba(0, 0, 0, 0.75) -1.1em 1.1em 0 0, rgba(0, 0, 0, 0.5) -1.5em 0 0 0, rgba(0, 0, 0, 0.5) -1.1em -1.1em 0 0, rgba(0, 0, 0, 0.75) 0 -1.5em 0 0, rgba(0, 0, 0, 0.75) 1.1em -1.1em 0 0;
  box-shadow: rgba(0, 0, 0, 0.75) 1.5em 0 0 0, rgba(0, 0, 0, 0.75) 1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) 0 1.5em 0 0, rgba(0, 0, 0, 0.75) -1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) -1.5em 0 0 0, rgba(0, 0, 0, 0.75) -1.1em -1.1em 0 0, rgba(0, 0, 0, 0.75) 0 -1.5em 0 0, rgba(0, 0, 0, 0.75) 1.1em -1.1em 0 0;
}

/* Animation */

@-webkit-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-moz-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-o-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.g-brd-gray-light-v4 {
    border-color: #eee !important;
}

.g-brd-bottom {
    border-bottom: solid 1px transparent !important;
}
article, aside, figcaption, figure, footer, header, hgroup, main, nav, section {
    display: block;
}

@media (min-width: 0){
.g-py-60 {
    padding-top: 4.28571rem !important;
    padding-bottom: 4.28571rem !important;
}

.no-gutters {
    margin-right: 0;
    margin-left: 0;
}
.no-gutters>.col, .no-gutters>[class*=col-] {
    padding-right: 0;
    padding-left: 0;
}

.g-brd-gray-light-v4 {
    border-color: #eee !important;
}}
@media (min-width: 768px){
.g-brd-right--md {
    border-right: solid 1px transparent !important;
}}
@media (min-width: 992px){
.col-lg-3 {
    -ms-flex: 0 0 25%;
    flex: 0 0 25%;
    max-width: 25%;
}}
@media (min-width: 768px){
.col-md-6 {
    -ms-flex: 0 0 50%;
    flex: 0 0 50%;
    max-width: 50%;
}}
@media (min-width: 0){
.g-py-20 {
    padding-top: 1.42857rem !important;
    padding-bottom: 1.42857rem !important;
}
.u-icon-v1.u-icon-size--xl, .u-icon-v1.u-icon-size--xl .u-icon__elem-regular, .u-icon-v1.u-icon-size--xl .u-icon__elem-hover {
    width: 5.14286rem;
    height: 5.14286rem;
    font-size: 2.85714rem;
}}
@media (min-width: 0){
.g-mb-10 {
    margin-bottom: 0.71429rem !important;
}}
@media (min-width: 0){
.g-mb-10 {
    margin-bottom: 0.71429rem !important;
}
.g-color-black {
    color: #000 !important;
}
.u-icon-v1, .u-icon-v1 .u-icon__elem-regular, .u-icon-v1 .u-icon__elem-hover {
    width: 2.57143rem;
    height: 2.57143rem;
    font-size: 1.42857rem;
}
.u-icon-v1, .u-icon-v2, .u-icon-v3, .u-icon-v4 {
    position: relative;
    display: inline-block;
    text-align: center;
    -webkit-transition: all .2s ease-in-out;
    -o-transition: all .2s ease-in-out;
    transition: all .2s ease-in-out;
}}
@media (min-width: 0){
.g-mb-5 {
    margin-bottom: 0.35714rem !important;
}

.g-font-weight-600 {
    font-weight: 600 !important;
}
.d-block {
    display: block!important;
}

.bg-icon_bag {
    width: 30px; height: 30px;
    background: url('/img/css_sprites.png') -10px -10px;
}

.bg-icon_door {
    width: 30px; height: 30px;
    background: url('/img/css_sprites.png') -60px -10px;
}

.bg-icon_driver {
    width: 30px; height: 30px;
    background: url('/img/css_sprites.png') -10px -60px;
}

.bg-icon_transmissao {
    width: 30px; height: 30px;
    background: url('/img/css_sprites.png') -60px -60px;
}
.car-icon {padding:30px 15px 0px 12px;}
.car-icon1 {padding: 5px 0px 25px 37px;}
.car-icon-margem {margin-right: 25px;}

.sembordas {border-radius: 0px !important;}
.mx-datepicker {width: 100% !important}
.btn-primary:hover, .btn-primary {background-color:#686868;border-color:#686868;}
}
@media (min-width: 768px) {
  #noticias .card:nth-child(1) {margin-left:0px !important;}
  #noticias .card:nth-child(3) {margin-right:0px !important;}
}

.tabs-langs div.tab-content div.active {background: #fff !important;}

.vueperslide__content-wrapper:not(.vueperslide__content-wrapper--outside-top):not(.vueperslide__content-wrapper--outside-bottom) {top:50% !important;}

.vueperslides__parallax-wrapper {padding-bottom: 350px !important;}
.vueperslide__content-wrapper {width:90%;margin: 0 auto;}
.imagesContent img {max-width:100%;}

.mx-calendar-content .cell:hover {
    color: #fff;
}
.risco {text-decoration: line-through;}

.clearfix {
  overflow: auto;
  clear: both;
}
.clearfix::after {
  content: "";
  clear: both;
  display: table;
}

.nav-tabs .nav-link.active {color:#fff !important;}
.nav-tabs .nav-link:focus, .nav-tabs .nav-link:hover {border:none !important; cursor: pointer;}

.Cancelled, .Archived {color:#dc3545;}
.Confirmed, .Processed {color: #28a745;}
.NoShow {color: #ffc107;}

.custom-file-upload {border: 1px solid #ccc;
    display: inline-block;
    padding: 6px 12px;
    cursor: pointer;}
input[type="file"] {
    display: none;
}

.btn-vertical {
    position:fixed;
    top:50%;
    right: -87px;
    z-index:2;
    border-radius: 3px 0px 0px 3px;
    -moz-transform:rotate(-90deg);
    -ms-transform:rotate(-90deg);
    -o-transform:rotate(-90deg);
    -webkit-transform:rotate(-90deg);
    width:230px;
    height:60px;
}
@media screen and (max-width:600px){
  .v--modal-box {
    width: 90% !important;
    left: 5% !important;
  }
}

@media screen and (max-width:600px){
  .cookie-popup {
    width: 90%; /* Full width for smaller screens */
    padding: 10px; /* Less padding on small screens */
  }
}

/* .Cookie--base div {width:50%;} */

h5.card-title {height: 48px; white-space: nowrap;overflow: hidden;text-overflow: ellipsis;}
.card-body h5+p {white-space: nowrap;overflow: hidden;text-overflow: ellipsis;}

.cookie-container {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0,0,0,0.50);
  z-index: 9999;
}

.cookie-popup {
  width: 90%; /* Adjust width for better mobile view */
  max-width: 600px; /* Maximum width to avoid being too large */
  padding: 15px; /* Adjust padding for smaller screens */
  background-color: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}

.cookie-popup .card {
  margin: 0;
  display: grid;
  grid-template-columns: 90% auto;
  align-items: center;
  border-bottom: 1px solid #ccc !important;
  margin-bottom: 10px;
}

.cookie-popup .card h6 {
  font-weight: bold;
}

.cookie-popup .card p {
  font-size: 10pt;
}

.cookie-popup .card input[type="checkbox"] {
  width: 22px;
  height: 22px;
  margin-left: auto;
  cursor: pointer;
}

/* Ensure the popup stays at the bottom center of the screen */
body {
  overflow-x: hidden; /* Prevent horizontal scrolling when the popup is visible */
}

.no-focus {
  text-decoration: none !important;
  outline: none !important;
}
</style>
